import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SectionsTab({
  sectionOrder,
  menuItems,
  newSectionName,
  onNewSectionNameChange,
  onAddSection,
  onMoveUp,
  onMoveDown,
  onRename,
  onDelete,
}) {
  const { t } = useTranslation();

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <h3>📂 {t('admin.sections.title', 'Sections')}</h3>
      </div>
      <div className="admin-card-body">
        <div className="sections-list">
          {sectionOrder.map((section, index) => (
            <div key={section} className="section-row">
              <span className="section-drag-handle">⠿</span>
              <span className="section-name">{section}</span>
              <span className="section-item-count">{menuItems.filter((i) => i.section === section).length}</span>
              <div className="section-actions">
                <button type="button" className="section-btn" onClick={() => onMoveUp(index)} disabled={index === 0}>↑</button>
                <button type="button" className="section-btn" onClick={() => onMoveDown(index)} disabled={index === sectionOrder.length - 1}>↓</button>
                <button type="button" className="section-btn rename" onClick={() => onRename(section)}>✏️</button>
                <button type="button" className="section-btn delete" onClick={() => onDelete(section)}>🗑️</button>
              </div>
            </div>
          ))}
        </div>
        <div className="add-section-row">
          <input
            type="text"
            className="form-input"
            placeholder={t('admin.sections.addPlaceholder', 'New section name...')}
            value={newSectionName}
            onChange={(e) => onNewSectionNameChange(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), onAddSection())}
          />
          <button type="button" className="btn btn-primary" onClick={onAddSection}>➕ {t('admin.sections.add', 'Add')}</button>
        </div>
      </div>
    </div>
  );
}
